export default "__VITE_ASSET__DSGH4VWb__"